export default __webpack_public_path__ + "static/media/alphabet-yellow-hash.ad5434f1.png";